// https://docs.google.com/document/d/1wyXY1KrNiIuydgbM0Z5nhnJ7SZrjomuLGMJxjNCsEj8/edit?ts=5f5202ff
export const gtagAccounts = {
  google_new_account: {
    id: 'G-KEVDP2QC4D'
  },
  bonkers_search_nb_insurance: {
    id: 'AW-815975425',
    broadband: {
      code: 'c7JQCLrVkNcBEIGYi4UD',
      options: {
        send_to: 'AW-815975425/c7JQCLrVkNcBEIGYi4UD',
        value: '',
        currency: 'EUR',
        transaction_id: ''
      }
    },
    car_insurance: {
      code: 'QTt7COix34MDEIGYi4UD',
      options: {
        send_to: 'AW-815975425/QTt7COix34MDEIGYi4UD',
        value: '',
        currency: 'EUR',
        transaction_id: ''
      }
    },
    energy: {
      code: 'TAvbCPDPkNcBEIGYi4UD',
      options: {
        send_to: 'AW-815975425/TAvbCPDPkNcBEIGYi4UD',
        value: '',
        currency: 'EUR',
        transaction_id: ''
      }
    },
    home_insurance: {
      code: 'yl4lCOGT6ucCEIGYi4UD',
      options: {
        send_to: 'AW-815975425/yl4lCOGT6ucCEIGYi4UD',
        value: '',
        currency: 'EUR',
        transaction_id: ''
      }
    },
    life_insurance: {
      code: 'z3tBCMvzn9cBEIGYi4UD',
      options: {
        send_to: 'AW-815975425/z3tBCMvzn9cBEIGYi4UD',
        value: '',
        currency: 'EUR',
        transaction_id: ''
      }
    },
    mortgage_protection: {
      code: 'oxrOCJbbkNcBEIGYi4UD',
      options: {
        send_to: 'AW-815975425/oxrOCJbbkNcBEIGYi4UD',
        value: '',
        currency: 'EUR',
        transaction_id: ''
      }
    }
  },
  bonkers_search_nb: {
    id: 'AW-925535893',
    broadband: {
      code: 'Oe-MCNvTrmYQlZ2quQM',
      options: {
        send_to: 'AW-925535893/Oe-MCNvTrmYQlZ2quQM',
        value: '',
        currency: 'EUR',
        transaction_id: ''
      }
    },
    car_insurance: {
      code: 'CiB2CO6wpZoYEJWdqrkD',
      options: {
        send_to: 'AW-925535893/CiB2CO6wpZoYEJWdqrkD',
        value: '',
        currency: 'EUR',
        transaction_id: ''
      }
    },
    energy: {
      code: 'kJCPCP3RrmYQlZ2quQM',
      options: {
        send_to: 'AW-925535893/kJCPCP3RrmYQlZ2quQM',
        value: '',
        currency: 'EUR',
        transaction_id: ''
      }
    },
    home_insurance: {
      code: 'iWtRCJmmr5oYEJWdqrkD',
      options: {
        send_to: 'AW-925535893/iWtRCJmmr5oYEJWdqrkD',
        value: '',
        currency: 'EUR',
        transaction_id: ''
      }
    },
    life_insurance: {
      code: 'pbmDCOa7uJoYEJWdqrkD',
      options: {
        send_to: 'AW-925535893/pbmDCOa7uJoYEJWdqrkD',
        value: '',
        currency: 'EUR',
        transaction_id: ''
      }
    },
    mortgage: {
      code: 'coQiCJidq2YQlZ2quQM',
      options: {
        send_to: 'AW-925535893/coQiCJidq2YQlZ2quQM',
        value: 67.0,
        currency: 'EUR',
        transaction_id: ''
      }
    },
    mortgage_protection: {
      code: 'xG76CJ6nw5oYEJWdqrkD',
      options: {
        send_to: 'AW-925535893/xG76CJ6nw5oYEJWdqrkD',
        value: '',
        currency: 'EUR',
        transaction_id: ''
      }
    }
  },
  bonkers_display_nb: {
    id: 'AW-1017247867',
    broadband: {
      code: 'S492CJ3cgAkQ-_CH5QM',
      options: {
        send_to: 'AW-1017247867/S492CJ3cgAkQ-_CH5QM',
        value: '',
        currency: 'EUR',
        transaction_id: ''
      }
    },
    car_insurance: {
      code: 'TexJCI7nroMDEPvwh-UD',
      options: {
        send_to: 'AW-1017247867/TexJCI7nroMDEPvwh-UD',
        value: '',
        currency: 'EUR',
        transaction_id: ''
      }
    },
    energy: {
      code: 'Zc6vCI3egAkQ-_CH5QM',
      options: {
        send_to: 'AW-1017247867/Zc6vCI3egAkQ-_CH5QM',
        value: '',
        currency: 'EUR',
        transaction_id: ''
      }
    },
    home_insurance: {
      code: '0ljzCOfOnOoCEPvwh-UD',
      options: {
        send_to: 'AW-1017247867/0ljzCOfOnOoCEPvwh-UD',
        value: '',
        currency: 'EUR',
        transaction_id: ''
      }
    },
    mortgage: {
      code: 'tUBRCOXDj14Q-_CH5QM',
      options: {
        send_to: 'AW-1017247867/tUBRCOXDj14Q-_CH5QM',
        value: 67.0,
        currency: 'EUR',
        transaction_id: ''
      }
    },
    mortgage_protection: {
      code: 'JJlVCJO49c4BEPvwh-UD',
      options: {
        send_to: 'AW-1017247867/JJlVCJO49c4BEPvwh-UD',
        value: '',
        currency: 'EUR',
        transaction_id: ''
      }
    },
    life_insurance: {
      code: 'Ya-kCOuO_c8BEPvwh-UD',
      options: {
        send_to: 'AW-1017247867/Ya-kCOuO_c8BEPvwh-UD',
        value: '',
        currency: 'EUR',
        transaction_id: ''
      }
    }
  },
  bonkers_search_brand: {
    id: 'AW-925180441',
    broadband: {
      code: 'q3oqCJeVw2YQmcSUuQM',
      options: {
        send_to: 'AW-925180441/q3oqCJeVw2YQmcSUuQM',
        value: '',
        currency: 'EUR',
        transaction_id: ''
      }
    },
    car_insurance: {
      code: 'nJSzCI-L4oMDEJnElLkD',
      options: {
        send_to: 'AW-925180441/nJSzCI-L4oMDEJnElLkD',
        value: 67.0,
        currency: 'EUR',
        transaction_id: ''
      }
    },
    energy: {
      code: 'E4emCJmctGYQmcSUuQM',
      options: {
        send_to: 'AW-925180441/E4emCJmctGYQmcSUuQM',
        value: '',
        currency: 'EUR',
        transaction_id: ''
      }
    },
    life_insurance: {
      code: 'e7CLCLuG2YMDEJnElLkD',
      options: {
        send_to: 'AW-925180441/e7CLCLuG2YMDEJnElLkD',
        value: 67.0,
        currency: 'EUR',
        transaction_id: ''
      }
    },
    home_insurance: {
      code: 'OpJyCJzTsIMDEJnElLkD',
      options: {
        send_to: 'AW-925180441/OpJyCJzTsIMDEJnElLkD',
        value: 67.0,
        currency: 'EUR',
        transaction_id: ''
      }
    },
    mortgage: {
      code: '2foNCNeWw2YQmcSUuQM',
      options: {
        send_to: 'AW-925180441/2foNCNeWw2YQmcSUuQM',
        value: 67.0,
        currency: 'EUR',
        transaction_id: ''
      }
    },
    mortgage_protection: {
      code: '_5-2CO_24YMDEJnElLkD',
      options: {
        send_to: 'AW-925180441/_5-2CO_24YMDEJnElLkD',
        value: 67.0,
        currency: 'EUR',
        transaction_id: ''
      }
    }
  }
};
